import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { userRoleItems } from "../../../utils/enum";

const useMenuData = () => {
  const auth = useSelector((state) => state.auth);
  const permissions = useSelector((state) => state.permissions);

  const [menu, setMenu] = useState([]);

  const admin = [
    {
      heading: "داشبورد",
      icon: "dashboard",
      subMenu: [
        {
          icon: "dashboard",
          text: "داشبورد",
          link: "/admin",
        },
        {
          icon: "list-thumb-alt",
          text: "خدمات",
          link: "/admin/services",
        },
        {
          icon: "headphone",
          text: "تیکت",
          link: "/admin/tickets",
        },
        {
          icon: "bell",
          text: "اعلان ها",
          link: "/admin/notifications",
        },
        // {
        //   icon: "home",
        //   text: "هتل ها",
        //   link: "/admin/hotels",
        // },
        // {
        //   icon: "light",
        //   text: "پرواز ها",
        //   link: "/admin/flights",
        // },
      ],
    },
    {
      heading: "مدیریت",
      icon: "server",
      subMenu: [
        {
          icon: "users",
          text: "ادمین ها",
          link: "/admin/admins",
        },
        {
          icon: "user-round",
          text: "پذیرنده ها",
          link: "/admin/receptions",
        },
        {
          icon: "building",
          text: "فروشگاه ها",
          link: "/admin/shops",
        },
        {
          icon: "user-c",
          text: "نمایندگان",
          link: "/admin/agents",
        },
        {
          icon: "user-circle",
          text: "مشتری ها",
          link: "/admin/customers",
        },
        {
          icon: "users-fill",
          text: "مسافران",
          link: "/admin/passengers",
        },
        {
          icon: "globe",
          text: "شهر ها",
          link: "/admin/geo",
        },
      ],
    },
    {
      heading: "گزارش ها",
      icon: "reports",
      subMenu: [
        {
          icon: "report-profit",
          text: "تراکنشات",
          link: "/admin/transactions",
        },
        {
          icon: "user-list",
          text: "رویدادنگاری",
          link: "/admin/logs",
        },
        {
          icon: "calendar-booking",
          text: "رزروهای اسنپ تریپ",
          link: "/admin/snapp-trip/books",
        },
        {
          icon: "home",
          text: "سفارشات هتل",
          link: "/admin/hotel-orders",
        },
        {
          icon: "light",
          text: "سفارشات پرواز",
          link: "/admin/fly-orders",
        },
        {
          icon: "list",
          text: "سفارشات پذیرندگان",
          link: "/admin/reception-orders",
        },
        {
          icon: "view-list-fill",
          text: "سفارشات فروشندگان",
          link: "/admin/shop-orders",
        },
      ],
    },
    {
      heading: "تنظیمات",
      icon: "setting",
      subMenu: [
        {
          icon: "light",
          text: "چارتر 724",
          link: "/admin/charter-724",
        },
        {
          icon: "stripe",
          text: "اسنپ تریپ",
          link: "/admin/snapp-trip",
        },
        {
          icon: "coins",
          text: "سود وب سرویس ها",
          link: "/admin/web-service-profit",
        },
        {
          icon: "setting",
          text: "تنظیمات",
          link: "/admin/setting",
        },
      ],
    },
  ];
  const agent = [
    {
      heading: "داشبورد",
      icon: "dashboard",
      subMenu: [
        {
          icon: "dashboard",
          text: "داشبورد",
          link: "/agent",
        },
        {
          icon: "list-thumb-alt",
          text: "خدمات",
          link: "/agent/services",
        },
        {
          icon: "headphone",
          text: "تیکت",
          link: "/agent/tickets",
        },
        {
          icon: "bell",
          text: "اعلان ها",
          link: "/agent/notifications",
        },
        // {
        //   icon: "home",
        //   text: "هتل ها",
        //   link: "/agent/hotels",
        // },
        // {
        //   icon: "light",
        //   text: "پرواز ها",
        //   link: "/agent/flights",
        // },
      ],
    },
    {
      heading: "مدیریت",
      icon: "server",
      subMenu: [
        {
          icon: "user-circle",
          text: "مشتری ها",
          link: "/agent/customers",
        },
        {
          icon: "users-fill",
          text: "مسافران",
          link: "/agent/passengers",
        },
      ],
    },
    {
      heading: "گزارش ها",
      icon: "reports",
      subMenu: [
        {
          icon: "report-profit",
          text: "تراکنشات",
          link: "/agent/transactions",
        },
        {
          icon: "home",
          text: "سفارشات هتل",
          link: "/agent/hotel-orders",
        },
        {
          icon: "light",
          text: "سفارشات پرواز",
          link: "/agent/fly-orders",
        },
        {
          icon: "list",
          text: "سفارشات پذیرندگان",
          link: "/agent/reception-orders",
        },
        {
          icon: "view-list-fill",
          text: "سفارشات فروشندگان",
          link: "/agent/shop-orders",
        },
      ],
    },
  ];
  const customer = [
    {
      heading: "داشبورد",
      icon: "dashboard",
      subMenu: [
        {
          icon: "dashboard",
          text: "داشبورد",
          link: "/customer",
        },
        {
          icon: "list-thumb-alt",
          text: "خدمات",
          link: "/customer/services",
        },
        {
          icon: "headphone",
          text: "تیکت",
          link: "/customer/tickets",
        },
        {
          icon: "home",
          text: "هتل ها",
          link: "/customer/hotels",
        },
        {
          icon: "light",
          text: "پرواز ها",
          link: "/customer/flights",
        },
        {
          icon: "qr",
          text: "بارکد کیف پول",
          link: "/customer/qr-code",
        },
        {
          icon: "bell",
          text: "اعلان ها",
          link: "/customer/notifications",
        },
      ],
    },
    {
      heading: "مدیریت",
      icon: "server",
      subMenu: [
        {
          icon: "users-fill",
          text: "مسافران",
          link: "/customer/passengers",
        },
      ],
    },
    {
      heading: "گزارش ها",
      icon: "reports",
      subMenu: [
        {
          icon: "report-profit",
          text: "تراکنشات",
          link: "/customer/transactions",
        },
        {
          icon: "home",
          text: "سفارشات هتل",
          link: "/customer/hotel-orders",
        },
        {
          icon: "light",
          text: "سفارشات پرواز",
          link: "/customer/fly-orders",
        },
        {
          icon: "list",
          text: "سفارشات پذیرندگان",
          link: "/customer/reception-orders",
        },
        {
          icon: "view-list-fill",
          text: "سفارشات فروشندگان",
          link: "/customer/shop-orders",
        },
      ],
    },
  ];
  const reception = [
    {
      heading: "داشبورد",
      icon: "dashboard",
      subMenu: [
        {
          icon: "dashboard",
          text: "داشبورد",
          link: "/reception",
        },
        {
          icon: "headphone",
          text: "تیکت",
          link: "/reception/tickets",
        },
        {
          icon: "info",
          text: "اطلاعات پذیرنده",
          link: "/reception/info",
        },
        {
          icon: "bell",
          text: "اعلان ها",
          link: "/reception/notifications",
        },
      ],
    },
    {
      heading: "مدیریت",
      icon: "server",
      subMenu: [
        {
          icon: "list",
          text: "دسته بندی ها",
          link: "/reception/categories",
        },
        {
          icon: "box",
          text: "محصولات",
          link: "/reception/products",
        },
      ],
    },
    {
      heading: "گزارش ها",
      icon: "reports",
      subMenu: [
        {
          icon: "report-profit",
          text: "تراکنشات",
          link: "/reception/transactions",
        },
        {
          icon: "list",
          text: "سفارشات پذیرندگان",
          link: "/reception/reception-orders",
        },
      ],
    },
  ];
  const shop = [
    {
      heading: "داشبورد",
      icon: "dashboard",
      subMenu: [
        {
          icon: "dashboard",
          text: "داشبورد",
          link: "/shop",
        },
        {
          icon: "headphone",
          text: "تیکت",
          link: "/shop/tickets",
        },
        {
          icon: "info",
          text: "اطلاعات فروشگاه",
          link: "/shop/info",
        },
        {
          icon: "scan",
          text: "اسکن بارکد",
          link: "/shop/qr-code-scanner",
        },
        {
          icon: "bell",
          text: "اعلان ها",
          link: "/shop/notifications",
        },
      ],
    },
    {
      heading: "گزارش ها",
      icon: "reports",
      subMenu: [
        {
          icon: "report-profit",
          text: "تراکنشات",
          link: "/shop/transactions",
        },
        {
          icon: "view-list-fill",
          text: "سفارشات فروشندگان",
          link: "/shop/shop-orders",
        },
      ],
    },
  ];

  const filterMenuItems = (menuItems) => {
    return menuItems
      .map((menu) => {
        if (menu.permission && !permissions[menu.permission]) return null;

        if (menu.subMenu) {
          const filteredSubMenu = filterMenuItems(menu.subMenu);
          menu.subMenu = filteredSubMenu.filter((item) => item !== null);
          return menu.subMenu.length > 0 ? menu : null;
        }

        return menu;
      })
      .filter((menu) => menu !== null);
  };

  useEffect(() => {
    const items = {
      [userRoleItems[0]]: admin,
      [userRoleItems[1]]: agent,
      [userRoleItems[2]]: customer,
      [userRoleItems[3]]: reception,
      [userRoleItems[4]]: shop,
    };
    setMenu(filterMenuItems(items[auth?.role || userRoleItems[0]]));
  }, [auth]);

  return menu;
};

export default useMenuData;
